"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputText = void 0;

var _styles = require("./styles");

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _jsxRuntime = require("react/jsx-runtime");

var InputText = function InputText(props) {
  var id = props.id,
      key = props.key,
      className = props.className,
      type = props.type,
      transparent = props.transparent,
      size = props.size,
      borderType = props.borderType,
      placeHolder = props.placeHolder,
      multiline = props.multiline,
      maxRows = props.maxRows,
      minRows = props.minRows,
      disabled = props.disabled,
      text = props.text,
      onChangeText = props.onChangeText,
      onEnter = props.onEnter,
      refInputText = props.refInputText;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
      id: id,
      className: "container-inputText " + className,
      borderType: borderType,
      size: size,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
        className: "inputText " + (["gray", "white", "black"].includes(type) ? type : "white") + (transparent ? " transparent" : " fill"),
        multiline: multiline,
        inputRef: refInputText,
        disabled: disabled,
        placeholder: placeHolder,
        label: undefined,
        minRows: minRows,
        maxRows: maxRows,
        variant: "outlined",
        value: text,
        onChange: function onChange(event) {
          return onChangeText && onChangeText(event.target.value);
        },
        onKeyDown: function onKeyDown(event) {
          if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            onEnter && onEnter(event);
          }
        }
      })
    }, key)
  });
};

exports.InputText = InputText;